import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { BasicContextInteface, IProduct } from '../interfaces/User.interface';
import { IMember } from '../interfaces/Member.interface';
import { useLoading } from './LoadingContext';
import { useAuth } from './AuthContext';
import { useFetch } from '../utils/FetchTemplate';

const MemberContext = createContext<{
    members: IMember[],
    setMembers?: React.Dispatch<React.SetStateAction<IMember[]>>,
    fetchMembers: () => Promise<void>

}>({
    members: [],
    setMembers: () => {},
    fetchMembers: () => Promise.resolve()
  });

export const MembersProvider: React.FC<BasicContextInteface> = ({ children }) => {

    const [members, setMembers] = useState<IMember[]>([]);
    const { loggedIn, logout } = useAuth();
    const { postData, getData } = useFetch()

    const fetchMembers = async () => {
        if (!loggedIn) return;
        getData<IMember[]>('/api/member/list').then((members) => {
          setMembers(members);
        }).catch().finally(() =>{
        })
    };
      
    useEffect(() => {
        fetchMembers();
    }, [loggedIn]);


    return (
        <MemberContext.Provider value={ { members, fetchMembers,setMembers } }>
            {children}
        </MemberContext.Provider>
    );
};

export const useMembers = () => useContext(MemberContext);

